var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLapizEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11948",
    "data-name": "Group 11948",
    transform: "translate(13164 1289)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 13,
    cy: 13.5,
    rx: 13,
    ry: 13.5,
    transform: "translate(-13164 -1289)",
    fill: "#394F65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(-13157.352 -1282.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(0 0.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7209",
    "data-name": "Path 7209",
    d: "M0,17.491a4.111,4.111,0,0,1,.251-.66,1.663,1.663,0,0,1,1.495-.862c1.557-.012,3.114,0,4.67,0a.59.59,0,1,1,0,1.181H1.842a.57.57,0,0,0-.661.642v8.065a.586.586,0,0,0,.652.654H9.9a.587.587,0,0,0,.646-.646v-4.6a.588.588,0,1,1,1.175.021V25.9a1.756,1.756,0,0,1-1.374,1.743.942.942,0,0,1-.2.018H1.7a1.589,1.589,0,0,1-1.414-.794A3.919,3.919,0,0,1,0,26.152Z",
    transform: "translate(0 -13.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7210",
    "data-name": "Path 7210",
    d: "M38.995,12.79l2.066,2.066c-.024.024-.053.058-.084.09L36.52,19.407a.635.635,0,0,1-.342.183c-.637.124-1.273.252-1.911.379-.266.053-.443-.111-.387-.372q.2-1,.406-2a.428.428,0,0,1,.114-.211q2.27-2.277,4.544-4.548C38.962,12.821,38.983,12.8,38.995,12.79Z",
    transform: "translate(-28.872 -10.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7211",
    "data-name": "Path 7211",
    d: "M75,3.325,72.91,1.237A13.019,13.019,0,0,1,73.956.269a1.42,1.42,0,0,1,1.865.214,1.43,1.43,0,0,1,.109,1.862C75.647,2.7,75.309,3,75,3.325Z",
    transform: "translate(-62.151 -0.014)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapizEdit);
export default __webpack_public_path__ + "static/media/lapiz_edit.c4b6c11ee3509c343456a106e86aa723.svg";
export { ForwardRef as ReactComponent };